import globalEvents from '@/services/GlobalEvents/GlobalEvents'
import { Events } from '@/services/GlobalEvents/constants'

export const logoutEvent = () => {
  globalEvents.emit(Events.authError)
}
